var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.241 352.8h-304v-216c0-66.274 53.726-120 120-120h64c66.274 0 120 53.726 120 120z",
    fill: "#7dc8aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.241 216.8h24c13.255 0 24-10.745 24-24v-24c0-13.255-10.745-24-24-24h-104c-13.255 0-24 10.745-24 24v40l8 16v16c0 8.836 7.163 16 16 16h-24c-8.837 0-16-7.164-16-16v-112h-48v32c0 8.836 7.163 16 16 16v64c0 26.51 21.49 48 48 48h40v22.059c0 6.365 2.529 12.47 7.029 16.971l8.971 8.971c-8.836 0-16 7.164-16 16h112c0-8.836-7.163-16-16-16l8.971-8.971c4.501-4.501 7.029-10.605 7.029-16.97v-70.06h-64v-8c0-8.836 7.164-16 16-16z",
    fill: "#147864"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m180.241 144.8h-20c-2.209 0-4 1.791-4 4 0 6.627 5.373 12 12 12h4c0 8.837 7.164 16 16 16v-24c0-4.418-3.582-8-8-8z",
    fill: "#329682"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.241 256.8h-24c-8.837 0-16-7.163-16-16v-16l-8-16v-40c0-13.255 10.745-24 24-24h104c13.255 0 24 10.745 24 24h-72c-4.418 0-8 3.582-8 8v32l-8 16v16c0 8.837-7.163 16-16 16z",
    fill: "#329682"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m172.241 80.8c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8v16h-32c-4.418 0-8 3.582-8 8s3.582 8 8 8h48v-32c0-8.836-7.163-16-16-16z",
    fill: "#329682"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.241 200.8h-4c-8.837 0-16-7.163-16-16v-6.667c0-2.209 1.791-4 4-4h4c8.837 0 16 7.163 16 16v6.667c0 2.209-1.791 4-4 4z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.241 200.8h4c8.837 0 16-7.163 16-16v-6.667c0-2.209-1.791-4-4-4h-4c-8.837 0-16 7.163-16 16v6.667c0 2.209 1.791 4 4 4z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 221.575,
    cy: 183.467,
    fill: "#aac3d7",
    r: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 258.908,
    cy: 183.467,
    fill: "#aac3d7",
    r: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m364.241 256.8c0-13.255-10.745-24-24-24s-24 10.745-24 24c0 7.107 3.091 13.489 8 17.884v78.116h32v-78.116c4.909-4.395 8-10.777 8-17.884z",
    fill: "#329682"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m372.241 144.8c-4.418 0-8-3.582-8-8 0-44.112-35.888-80-80-80-4.418 0-8-3.582-8-8s3.582-8 8-8c52.935 0 96 43.065 96 96 0 4.418-3.581 8-8 8z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m372.241 184.8c-4.418 0-8-3.582-8-8v-8c0-4.418 3.582-8 8-8s8 3.582 8 8v8c0 4.418-3.581 8-8 8z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 252.241,
    cy: 464.8,
    fill: "#9b5faa",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 364.241,
    cy: 464.8,
    fill: "#9b5faa",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 140.241,
    cy: 464.8,
    fill: "#9b5faa",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.241 400.8h-400l48-48h304z",
    fill: "#faa51e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.241 464.8h-304c-26.51 0-48-21.49-48-48v-16h400v16c0 26.51-21.49 48-48 48z",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.241 464.8h152c26.51 0 48-21.49 48-48h-176c-13.255 0-24 10.745-24 24z",
    fill: "#32283c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.241 400.8-48-48h-152v48z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 76.241,
    cy: 376.8,
    fill: "#9b5faa",
    r: 10.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 193.575,
    cy: 376.8,
    fill: "#9b5faa",
    r: 10.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 310.908,
    cy: 376.8,
    fill: "#784687",
    r: 10.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 428.241,
    cy: 376.8,
    fill: "#784687",
    r: 10.667
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m172.241 68.8c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-4c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 172.241,
    cy: 88.8,
    fill: "#fff",
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/ufo.18441c2349eb0cb8c45112d32674e90d.svg";
export { ForwardRef as ReactComponent };